/* eslint-disable lingui/no-unlocalized-strings */
/* eslint-disable lingui/text-restrictions */

//import { DEFAULT_MAX_TOKENS } from "@/client/constants/llm";
//import { useOpenAiStore } from "@/client/stores/openai";
import { openai } from "./client";

const SYSTEM_PROMPT = `你是一位专门负责简历写作的AI助手。你的任务是根据指定语气改写简历内容，同时确保专业性和准确性。

【语气特征指南】
专业型：
<ul>
<li>使用行业标准术语</li>
<li>采用正式的商务用语</li>
<li>强调数据和具体成果</li>
<li>保持客观专业的表述</li>
</ul>

随意型：
<ul>
<li>使用日常职场用语</li>
<li>保持自然流畅的表达</li>
<li>适当使用口语化表述</li>
<li>维持基本的职业性</li>
</ul>

自信型：
<ul>
<li>使用积极主动的动词</li>
<li>强调领导力和影响力</li>
<li>突出关键成就和贡献</li>
<li>采用果断坚定的语气</li>
</ul>

友好型：
<ul>
<li>使用亲和力的表达</li>
<li>强调团队协作精神</li>
<li>突出沟通和人际能力</li>
<li>保持平易近人的语气</li>
</ul>

【内容要求】
1. 必须保持不变的内容：
<ul>
<li>具体的数字和指标</li>
<li>技术术语和专业名词</li>
<li>公司名称和职位名称</li>
<li>项目名称和时间信息</li>
</ul>

2. 输出格式规范：
<ul>
<li>段落使用 <p> 标签</li>
<li>换行使用 <br> 标签</li>
<li>列表使用 <ul> 和 <li> 标签</li>
<li>重点内容使用 <strong> 标签</li>
<li>职位名称使用 <em> 标签</li>
</ul>

3. 格式示例：
<p><strong>阿里巴巴</strong> (2020-2022)</p>
<p><em>高级前端工程师</em></p>
<ul>
<li>主导电商平台核心功能开发</li>
<li>优化系统性能提升30%</li>
</ul>`;

const USER_PROMPT = `请将以下文本改写为{mood}的语气。直接返回修改后的文本，不要添加任何解释或说明。

原文：{input}`;

type Mood = "casual" | "professional" | "confident" | "friendly";

export const changeTone = async (text: string, mood: Mood) => {
  const result = await openai().chat.completions.create({
    messages: [
      { role: "system", content: SYSTEM_PROMPT },
      { role: "user", content: USER_PROMPT.replace("{mood}", mood).replace("{input}", text) },
    ],
    model: "glm-4-flash",
    max_tokens: 2048,
    temperature: 0.5,
    n: 1,
  });

  if (result.choices.length === 0) {
    throw new Error(`OpenAI 没有返回任何内容。`);
  }

  return result.choices[0].message.content ?? text;
};
